import { render, staticRenderFns } from "./view-publish-detail.vue?vue&type=template&id=50f8960c&scoped=true&"
import script from "./view-publish-detail.vue?vue&type=script&lang=js&"
export * from "./view-publish-detail.vue?vue&type=script&lang=js&"
import style0 from "./view-publish-detail.vue?vue&type=style&index=0&id=50f8960c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f8960c",
  null
  
)

export default component.exports